<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill="#ECEFF1" />
    <g opacity="0.4" clip-path="url(#clip0_2111_53545)">
      <path
        d="M21.5 10.667V21.4945C21.5008 21.6039 21.48 21.7124 21.4388 21.8138C21.3976 21.9152 21.3369 22.0075 21.2601 22.0855C21.1832 22.1634 21.0918 22.2254 20.991 22.268C20.8901 22.3106 20.7819 22.3329 20.6725 22.3337H7.3275C7.10818 22.3337 6.89783 22.2466 6.74266 22.0916C6.5875 21.9366 6.50022 21.7263 6.5 21.507V6.49366C6.5 6.04616 6.87417 5.66699 7.335 5.66699H16.4975L21.5 10.667ZM19.8333 11.5003H15.6667V7.33366H8.16667V20.667H19.8333V11.5003ZM10.6667 9.83366H13.1667V11.5003H10.6667V9.83366ZM10.6667 13.167H17.3333V14.8337H10.6667V13.167ZM10.6667 16.5003H17.3333V18.167H10.6667V16.5003Z"
        fill="#263238" />
    </g>
    <defs>
      <clipPath id="clip0_2111_53545">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
}
</script>